import { setStoredMapSectionOrder, useMapSectionOrder } from '../utils/clientSettings';
import { OrderControl } from './OrderControl';

export function CityOrderControl({ showOtherWorlds }: { showOtherWorlds: boolean }) {
  const order = useMapSectionOrder();
  return <OrderControl title="City order" order={order} onChange={setStoredMapSectionOrder}
    visibleItems={order.filter(name => showOtherWorlds || name !== 'Other Worlds')} itemAttribute="data-map-section" />;
}
